export const environment = {
  production: true,
  cms_host: 'https://api.21bit.com',
  api_host: 'https://api.21bit.com/api',
  app_host: 'https://www.21bit.com',
  ss_api_host: 'https://21bit.com/api',
  ss_host: 'https://21bit.com',
  telegramApp_api_host: 'https://api.21bit.cc/api',
  assets_host: 'https://media.21bit.com',
  error_host: 'https://error.21bit.com',
  mlh_host: 'https://mlh.21bit.com',
  redirector_host: 'https://api.dstat.site/api',
  wr_websocket: 'https://ue.gmngeng.com',
  zendesk_host: 'https://zendesk.dstat.site',
};

export enum BannerType {
  TOP_SLIDER = 20,
  TOP_SLIDER_FIAT = 25,
  BOTTOM_SLIDER = 6,
  BOTTOM_STICKY = 7,
  CONTINUOUS_CREEPING_LINES = 14,
  CREEPING_LINES_BY_TIME = 13,
  TOP_FEATURE = 21,
  REGISTER_BANNER = 22,
  REGISTER_BANNER_FIAT = 26,
  MOBILE_APP = 27
}

export enum BlogType {
  TEXT = '1',
  VIDEO = '2'
}

export enum StaticContentType {
  LOYALTY_STATUSES = 24,
  BUY_CRYPTO = 22,
  VIP_LEVELS = 28,
}

export enum TransactionLimit {
  MAX_COUNT = 40,
  STORAGE_KEY = 'transactionLimit',
  DISABLED_TIME = 10
}

export const MOBILE_APP_ID = '1066c362ce63d09b809961854eaf72b04';
export const MOBILE_APP_DECODE_MAP = 'towquysnkdejim_fbra.g/pvhlx:zc-1234567890'
